import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { MydocmaSettings, MYDOCMASETTINGS } from "@mydocma/core";
import { Project, ProjectStructureTree, ProjectStructureNode } from "@mydocma/project";
import { map, Observable, tap } from "rxjs";
import { BasedataService } from "../../shared/basedata.service";
import { StructureNode } from "./structure.model";
import { BpConfigService } from "../../config/bp-config.service";

@Injectable({
  providedIn: 'root'
})
export class StructureApiService extends BasedataService {

  endpoint: string;

  constructor(private http: HttpClient, configService: BpConfigService, @Inject(MYDOCMASETTINGS) private mydocmaConfig: MydocmaSettings) {
    super(configService);
  }

  get(project: Project): Observable<ProjectStructureTree> {

    return this.http.get<ProjectStructureTree[]>(`${this.mydocmaConfig.apiUrl}/customers/${project.customerId}/projects/${project.id}/structures`)
    .pipe(
      map(ss => {
        const arr = ss ?? [];
        const uidById = new Map<string, string>();
        arr.forEach((s: any) => {
          const uid = s?.mydocmaUid ?? s?.myDocmaUid;
          if (s?.id && uid) uidById.set(s.id, uid);
        });
        const tree = ProjectStructureTree.loadTree(ss);
        this.assignMyDocmaUid(tree, uidById);
        return tree;
      }),
      tap(tree => tree.projectId = project.id)
    );

  }

  private assignMyDocmaUid(node: ProjectStructureNode, uidById: Map<string, string>): void {
    if (!node) return;
    const uid = uidById.get(node.id);
    if (uid) (node as StructureNode).myDocmaUid = uid;
    node.children?.forEach(child => this.assignMyDocmaUid(child, uidById));
  }
}
